export const WHATS_NEW_FEATURE = 'whats_new'

export const CHANGELOG_RELEASE_LIST_COUNT = 10
